import Icon from './Icon'

const Credits = ( ) =>
{
  return (
    <div>
      <Icon icon="rebel"/>Autoproef.nl by <a href="mailto:sander@falise.com?subject=Wimedo app" target="_blank" rel="noreferrer">Falise.com</a> &copy; 2021 - { new Date().getFullYear() }
    </div>
  )
}


export default Credits